import steveImg from '../assets/steve.png';
import davidImg from '../assets/david.png';
import patrikImg from '../assets/patrik.png';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { Customers } from '../components/Customers';
import { WhatWeDo } from '../components/WhatWeDo';
import { ServicesSection } from '../components/ServicesSection';
import { Employees } from '../components/Employees';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
import styled from 'styled-components';

const HomeContainer = styled.div`
  font-family: 'Montserrat', 'Roboto', sans-serif;
  overflow-x: hidden;
`;

const employees = [
  {
    name: 'Steve Widinghoff',
    experienceLevel: 'Worked professionally since 2008',
    mainFocus: 'Scalable microservices, Backend, Architecture',
    techStack: 'Java, Kotlin, GCP and much much more',
    linkedinUrl: 'steve-widinghoff',
    image: steveImg
  },
  {
    name: 'David Iren',
    experienceLevel: 'Worked professionally since 2012',
    mainFocus: 'Frontend development, Cloud infrastructure, DevOps',
    techStack: 'React, TypeScript, AWS, Docker and more',
    linkedinUrl: 'david-iren',
    image: davidImg
  },
  {
    name: 'Patrik Wall',
    experienceLevel: 'Worked professionally since 2025',
    mainFocus: 'Vibe coding',
    techStack: 'AI, LLM, Backend, Frontend',
    linkedinUrl: 'patrik-wall',
    image: patrikImg
  }
];

export function Homepage() {
  return (
    <HomeContainer>
      <Navigation />
      <HeroSection />
      <Customers />
      <WhatWeDo />
      <ServicesSection />
      <Employees employees={employees} />
      <ContactSection />
      <Footer />
    </HomeContainer>
  );
}
